export default "__VITE_ASSET__BtrvU2jr__"